<div class="container center">
    <filter *ngIf="users" [users]="users"></filter>
    <div class="content">
        <div class="top">
            <h1>{{text.SEARCH_RESULT_TEXT}}</h1>
            <button mat-stroked-button class="hidden right" mat-button>
                <mat-icon class="icon" aria-hidden="false" aria-label="Export icon">insert_drive_file</mat-icon>
                {{text.EXPORT}}
            </button>
        </div>
        <mat-divider></mat-divider>
        <div class="pinner-bkg" *ngIf="isLoading">
            <div class="pinner">
              <mat-spinner></mat-spinner>
            </div>
          </div>
        <div class="items" *ngIf="!isLoading">
            <result-item [request]="request" *ngFor="let request of filteredRequests"></result-item>
        </div>
        <div class="paginition">
            <mat-paginator [length]="pageInfo.total" [pageSize]="pageInfo.pageSize" [pageSizeOptions]="pageInfo.options"
                (page)="onPageChanged($event)">
            </mat-paginator>
        </div>
    </div>
</div>